import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import type {
    PageBuilderModuleMetaProps,
    TextColumnProps,
} from '@modules/page-builder/types';
import { TextTypeEnum } from 'generated/graphql';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import RichTextDisplay from '../../common/rich-text/display/RichTextDisplay';
import { QuoteContainer } from '../single-paragraph-module/SingleParagraphModule.style';

interface QuoteModuleProp extends PageBuilderModuleMetaProps {
    column: TextColumnProps;
}

const QuoteModule = ({ column, meta }: QuoteModuleProp) => {
    const { mobile } = useAppDisplayModeContext();
    const { css } = useStyles();

    const clickProxy = useWebsiteTrackingProxy({
        professionalID: meta?.professional?.id,
        professionalTitle: meta?.professional?.title,
        itemType: meta?.itemType,
    });

    if (mobile && !column.content) {
        return null;
    }

    return (
        <div className={css(QuoteContainer)} onClick={clickProxy}>
            <RichTextDisplay
                textType={TextTypeEnum.Quote}
                contentHTML={column.contentHTML}
            />
        </div>
    );
};

export default QuoteModule;
